export const CHAT_V2_EMPTY_HEADLINE = 'What can AlphaSearch help you find?';
export const CHAT_V2_INPUT_PLACEHOLDER = 'Ask about companies, industries, markets...';

export const CHAT_V2_SUGGESTED_PROMPTS = [
  {
    label: 'Find SaaS companies in New York',
    prompt: 'Find SaaS companies in New York.',
  },
  {
    label: 'Show fast-growing healthcare companies',
    prompt: 'Show fast-growing healthcare companies.',
  },
  {
    label: 'Find companies similar to Stripe',
    prompt: 'Find companies similar to Stripe.',
  },
  {
    label: 'Which cybersecurity companies have 50–200 employees?',
    prompt: 'Which cybersecurity companies have 50–200 employees?',
  },
  {
    label: 'Find upcoming fintech conferences',
    prompt: 'Find upcoming fintech conferences.',
  },
  {
    label: 'Compare companies in this search',
    prompt: 'Compare companies in this search.',
  },
];

/**
 * Curated short-list shown on mobile in the Chat empty state.
 * Kept to 6 prompts (2 visible rows at typical chip wrap) so the screen
 * stays light and the input remains the primary focus.
 */
export const CHAT_V2_MOBILE_PROMPTS = [
  'Find SaaS companies in New York',
  'Find payment processors',
  'Show healthcare companies in Florida',
  'Find fintech companies with more than 20 employees',
  'Display dental companies in Wisconsin',
  'Find engineering companies in Ohio',
];

export const CHAT_V2_MARQUEE_ROWS = [
  [
    'Find SaaS companies in New York',
    'Display pest control companies in Arizona',
    'Find similar companies',
    'Find Managed Service Providers in Minnesota',
    'Discover healthcare operators',
    'Find industrial services firms',
  ],
  [
    'Show longevity and wellness companies',
    'Find companies that do payment processing',
    'Which cybersecurity firms have 50 to 200 employees?',
    'Find upcoming fintech conferences',
    'Build a list of waste management businesses in Texas',
    'Find med spas in California',
  ],
  [
    'Find manufacturing companies in Ohio',
    'Explore engineering companies with more than 20M in revenue',
    'Show HVAC companies in Florida',
    'Find solar companies under $5M revenue',
    'Search for home care companies in Arizona',
    'Show me industrial cleaning companies in Colorado',
  ],
];

export const CHAT_V2_SIDEBAR_EXPANDED_WIDTH = 216;
export const CHAT_V2_SIDEBAR_COLLAPSED_WIDTH = 52;
export const CHAT_V2_RECENT_SESSION_LIMIT = 5;
